// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

// Import styles
import "../assets/styles/components/blogs-selector-modal.scss";

// Import Components
import {Modal} from "antd";
import {LinkButton} from "./buttons/buttons";
import {InputGroup} from "./uiElements/inputGroup";

// Import utils
import {GetBlogsInModal} from "../redux/actions";
import {mapStateToProps} from "../redux/mapStateToProps";
import {changeStateInputValue} from "../utils/helperFunctions";
import InfiniteScroll from "react-infinite-scroller";
import BlogCard from "./cards/BlogCard";
import { iconCloseDark, iconSearch } from "../assets/images";

class BlogsSelectorModal extends Component {
    constructor() {
        super();
        this.state = {
            selectedBlogs: [],
            text: '',
        };
        this.inputElement = React.createRef();
        this.getSearchValue = changeStateInputValue.bind(this);
        this.selectBlog = this.selectBlog.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.insertBlogs = this.insertBlogs.bind(this);
        this.loadMoreItems = this.loadMoreItems.bind(this);
        this.getBlogsList = this.getBlogsList.bind(this);
    }

    componentDidMount() {
        const {blogsInModal} = this.props;
        this.props.GetBlogsInModal();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {isOpen, appendBlogs} = this.props;
        if (!prevProps.isOpen && isOpen && Array.isArray(appendBlogs)) {
            this.setState({
                selectedBlogs: appendBlogs
            })
        }
    }

    selectBlog(item, isSelected) {
        const {multiSelect} = this.props;
        const {selectedBlogs} = this.state;
        if (multiSelect) {
            this.setState({
                selectedBlogs: isSelected ? selectedBlogs.filter(m => m.id !== item.id) : [item, ...selectedBlogs]
            })
        } else {
            this.setState({
                selectedBlogs: isSelected ? [] : [item]
            })
        }
    }

    insertBlogs() {
        const {selectedBlogs} = this.state;
        this.props.getSelectedBlogs(selectedBlogs);
        this.closeModal();
    }

    closeModal() {
        this.setState({
            selectedBlogs: []
        });
        this.props.closeModal();
    }

    getBlogsList() {
        const {text} = this.state;
        this.props.GetBlogsInModal({
            reset: true,
            text
        });
    }

    loadMoreItems() {
        const {text} = this.state;
        const {blogsInModal} = this.props;
        const {hasMore} = blogsInModal;
        hasMore && this.props.GetBlogsInModal({
            reset: false,
            offset: blogsInModal.itemsList.length,
            text
        });
    };


    render() {
        const {isOpen, blogsInModal, disabledBlogs} = this.props;
        const {selectedBlogs, text} = this.state;
        console.log('blogsInModal', blogsInModal)
        return <Modal
            open={isOpen}
            onCancel={this.closeModal}
            wrapClassName={"custom-modal"}>

            <div className="blogs-selector-modal">
                <div className="blogs-selector-modal-inner">
                    <div className="selector-modal-header">
                        <div className="selector-modal-title">
                            <h1>Բլոգներ</h1>
                        </div>
                        <InputGroup
                            inputType={"input"}
                            type={'text'}
                            name={'text'}
                            value={text}
                            placeholder={'Փնտրել...'}
                            onChange={this.getSearchValue}>
                            <div className={'search-icon'} onClick={this.getBlogsList}>
                                <img src={iconSearch} alt=""/>
                            </div>
                        </InputGroup>
                        <button className="selector-modal-closing-btn"
                                onClick={this.closeModal}>
                            <img src={iconCloseDark}
                                 className="close_icon" alt=""/>
                        </button>
                    </div>
                    <div className={'blogs-items-wrapper'}>
                        <InfiniteScroll
                            hasMore={blogsInModal?.hasMore}
                            loadMore={this.loadMoreItems}
                            pageStart={0}
                            className={'blogs'}
                            useWindow={false}
                            initialLoad={false}>
                            {blogsInModal && !!blogsInModal?.itemsList?.length && blogsInModal.itemsList.map((item) => {
                                const isSelected = selectedBlogs?.find(v => v.id === item.id)
                                const isDisabled = disabledBlogs?.find(id => id === item.id);
                                return <BlogCard key={item?.id}
                                                    isSelected={!!isSelected}
                                                    isDisabled={isDisabled}
                                                    inSelectorModal={true}
                                                    onSelect={this.selectBlog}
                                                    data={item}/>
                            })}
                        </InfiniteScroll>

                    </div>
                    <div className="choose-button">
                        <LinkButton title={'Ընտրել'}
                                    disabled={!selectedBlogs.length}
                                    cb={this.insertBlogs}/>
                    </div>
                </div>
            </div>
        </Modal>
    }
}

BlogsSelectorModal.defaultProps = {
    multiSelect: true,
}
const mapDispatchToProps = {
    GetBlogsInModal
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogsSelectorModal);
